import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./lang/locales/en.json";
import hi from "./lang/locales/hi.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    hi: {
      translation: hi,
    },
  },

  lng: "hi",
  fallbackLng: "hi",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
